(function () {
  var REFERENCE_WIDTH = 1440;
  var MIN_SCALE = 0.65;
  var MAX_SCALE = 1.2;
  var MOBILE_REFERENCE_WIDTH = 402;
  var MOBILE_BREAKPOINT = 990;
  var MOBILE_MIN_SCALE = 0.78;
  var MOBILE_MAX_SCALE = 1.2;
  var READY_CLASS = 'fluid-type-ready';
  var PENDING_CLASS = 'fluid-type-pending';
  var FALLBACK_MS = 150;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function markFluidTypeReady() {
    var root = document.documentElement;
    root.classList.remove(PENDING_CLASS);
    root.classList.add(READY_CLASS);
  }

  function applyFluidTypeScale() {
    var width = window.innerWidth || document.documentElement.clientWidth || REFERENCE_WIDTH;
    var scale = clamp(width / REFERENCE_WIDTH, MIN_SCALE, MAX_SCALE);
    var mobileScale = 1;

    if (width <= MOBILE_BREAKPOINT) {
      mobileScale = clamp(width / MOBILE_REFERENCE_WIDTH, MOBILE_MIN_SCALE, MOBILE_MAX_SCALE);
    }

    document.documentElement.style.setProperty('--fluid-type-scale', String(scale));
    document.documentElement.style.setProperty('--fluid-type-scale-mobile', String(mobileScale));
    markFluidTypeReady();
  }

  applyFluidTypeScale();
  window.addEventListener('resize', applyFluidTypeScale, { passive: true });

  window.setTimeout(markFluidTypeReady, FALLBACK_MS);
})();
